import * as React from 'react';
import { V3Routes } from '../../../routes';
import { Link } from 'react-router-dom';
import './cancellationPolicy.module.scss';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { FlagKeys } from '../../../../mainv2/states/CurrentUserState';

export const CancellationPolicy = () => {
  // TODO: 削除 she-4766
  const showNewCancellationPolicy = GlobalStatesV3.currentUser.hasEnabledFlagKey(
    FlagKeys.CANCELLATION_PERIOD_FOR_RESERVATION
  );

  return showNewCancellationPolicy ? (
    <div styleName="cancellation-policy">
      <div styleName="header">無断キャンセルに関して</div>
      <ul styleName="body">
        <p>
          やむを得ないご事情でキャンセルをする場合は、必ず<span styleName="red">前日の18時までに</span>
          <Link to={V3Routes.reservations()} styleName="link">
            マイページ
          </Link>
          よりキャンセル手続きをお願いいたします（運営へのキャンセル完了のご連絡は不要です）。
        </p>
        <p>
          18時を超えるとキャンセル不可となり「直前・無断キャンセル」としてカウントし、累計キャンセル回数をマイページ上で告知させていただきます。
          <br />
          故意と思われる状況や、あまりにも頻度が多い場合、ご連絡の上サービス利用を停止させていただく場合がございますので、予めご了承ください。
        </p>
        <p styleName="supplement">
          ※設備の不具合／システムエラーの発生／予約の過度な集中／急激な会員数増加／その他事情が発生した場合、サービスの提供を一部休止させていただく場合がございます。予めご了承くださいませ。
        </p>
      </ul>
    </div>
  ) : (
    <div styleName="cancellation-policy">
      <div styleName="header">無断キャンセルに関して</div>
      <ul styleName="body">
        <p>
          ・故意と思われる状況が伺える場合や、頻度が多い場合のみ、ご連絡を差し上げた上でサービスのご利用を停止させていただく場合がございます。
        </p>
        <p>
          ※体調不良や家庭の事情などの理由で当日キャンセルをする場合は、
          <span styleName="red">必ず開始時刻前までに</span>
          <Link to={V3Routes.reservations()} styleName="link">
            マイページ
          </Link>
          よりキャンセル手続きをお願いいたします。
          <br />
          なお、運営へのキャンセルのご連絡は不要です。
        </p>
      </ul>
    </div>
  );
};
